import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { WindowService } from '@app/core/services';
import { IconComponent } from '../../utils/icon/icon.component';

@Component({
  selector: 'app-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss'],
  imports: [IconComponent],
})
export class SlideComponent {
  @ViewChild('container', { static: true }) container: ElementRef<HTMLElement>;
  /**
   * Number of items in the carousel
   */
  @Input() steps: number;

  public step = 0;

  constructor(
    private cdr: ChangeDetectorRef,
    private windowService: WindowService,
  ) {}

  /**
   * Number of pixels representing the actual width of the element.
   */
  get scrollWidth(): number {
    return this.container.nativeElement.scrollWidth;
  }

  /**
   * Number of pixels representing the item width if the number of items is provided;
   * if not, use clientWidth;
   * this is the number of pixels moving when user clicks on nav buttons
   */
  get stepWidth(): number {
    return this.scrollWidth / this.steps;
  }

  /**
   * Returns true until user has scroll all the way left
   */
  get showLeftBtn(): boolean {
    return this.step > 0;
  }

  /**
   * Returns true until user has scroll all the way right
   */
  get showRightBtn(): boolean {
    return this.step < this.steps - 1;
  }

  /**
   * Navigate left or right
   */
  nav(index: number): void {
    const duration = this.stepWidth / 2;
    this.step = index;
    this.windowService.scrollX(this.container.nativeElement, this.stepWidth * index, duration).then(() => this.cdr.detectChanges());
  }
}
